const apiMethods = {
  filters: {
    zygdFilter: function (num) {
      console.log(num);
      if (num === undefined && num !== 0) {
        return "--";
      } else {
        if (num === 0) {
          return "未变";
        } else {
          return num + "%";
        }
      }
    },

    zygdColor: function (num) {
      if (num && num !== 0) {
        if (num > 0) {
          return "red";
        } else if (num < 0) {
          return "green";
        }
      } else {
        return "";
      }
    },
    bkfsText: function (num) {
      if (!num && num !== 0) {
        return "--";
      } else {
        if (num > 0) {
          return "+" + num + "%";
        } else {
          return num + "%";
        }
      }
    },

    timeFream: function (str) {
      if (str) {
        return (
          str.substr(0, 4) + "-" + str.substr(4, 2) + "-" + str.substr(6, 2)
        );
      }
    },
  },
  methods: {
    /**
     *  获取 url 参数
     *
     * @param {string} [paramName] 参数名
     */
    getUrlQuery: function (paramName) {
      var url = document.location.toString();
      var arrObj = url.split("?");
      if (arrObj.length > 1) {
        var arrPara = arrObj[1].split("&");
        var arr;
        for (var i = 0; i < arrPara.length; i++) {
          arr = arrPara[i].split("=");

          if (arr != null && arr[0] === paramName) {
            return arr[1];
          }
        }
        return "";
      } else {
        return "";
      }
    },
    /**
     *  数值格式化 (添加万、亿等单位，并取两位小数)
     *
     * @param {number} [value] 数值
     * @param {number} [fixed] 保留小数位数，默认 2
     * @param {number} [isZero] 小数部分如果为零是否显示，默认显示
     */
    process: function (value, fixed, isZero) {
      if (!fixed) {
        fixed = 2;
      }
      if (value) {
        if (!isNaN(value)) {
          value = Number(value);
          let len = parseInt(Math.abs(value), 10).toString().length;
          value =
            (len > 12 && value / 1000000000000) ||
            (len > 8 && value / 100000000) ||
            (len > 4 && value / 10000) ||
            value;
          if (
            !isZero ||
            (!/^[-+]?\d*$/.test(value.toString()) &&
              value.toString().split(".")[1].length > fixed)
          ) {
            value = value.toFixed(fixed);
          }
          value =
            (len > 12 && value + "万亿") ||
            (len > 8 && value + "亿") ||
            (len > 4 && value + "万") ||
            value;
        }
      } else if (value === 0) {
        value = "0.00";
      } else {
        value = "--";
      }
      return value;
    },
    /**
     * 处理小数位保留
     * @param {*} val  数值
     * @param {*} str 单位
     * @param {*} len 小数点长度
     * @returns  返回指定单位以及小数点长度的str
     */

    gainsCheck: function (val, len, str) {
      if (val || val === 0) {
        var multiple = Math.pow(10, len);
        return (Math.round(val * multiple) / multiple).toFixed(len) + str;
      } else {
        return "--";
      }
    },

    /**
     * 处理json 请求地址的code 部分
     * @param {string} 股票代码
     */
    stockCodeUrl: function (str) {
      if (str) {
        return str.substr(0, 2) + "/" + str.substr(-2) + "/" + str.substr(2);
      }
    },

    goScrollTop: function () {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },

    /**
     * 获取当前时间 年月日
     */

    getTime: function () {
      var date = new Date();
      var nowMonth = date.getMonth() + 1;
      nowMonth = nowMonth >= 10 ? nowMonth : "0" + nowMonth;
      var strDate = date.getDate();
      var year = date.getFullYear();
      return year + "" + nowMonth + "" + strDate;
    },

    // 处理股本结构数据
    checkGbjgData: function (list) {
      let that = this;
      if (list.data.length) {
        for (let i = 0; i < list.data.length; i++) {
          if (list.data[i].ksrq <= that.getTime() <= list.data[i].jzrq) {
            return list.data[i];
          }
        }
      } else {
        return null;
      }
    },

    gains: function (val, str) {
      if (val || val === 0) {
        val = Number(val.replace("港元", ""));
        var multiple = Math.pow(10, 3);
        return (Math.round(val * multiple) / multiple).toFixed(3) + str;
      } else {
        return "--";
      }
    },

    // 处理货币显示问题
    checkMoney: function (str) {
      switch (str) {
        case "HKD":
          return "港币";
          break;
        case "CNY":
          return "人民币";
          break;
        case "USD":
          return "美元";
          break;
        default:
          return str
          break;
      }
    },
  },
};

export default apiMethods;
